import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button, Form, Input, Spin } from 'antd';
import { get } from 'lodash';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../AppContext';
import logo from '../../assets/logo.png';
import { ROUTES } from '../../common/constants';
import { formValidatorRules } from '../../common/utils';
import { LOGIN } from './graphql/Mutations';

const { required, email } = formValidatorRules;

const Login = (props) => {
  const { initializeAuth } = useContext(AppContext);
  const { history } = props;
  const [loginMutate, { loading: loginLoading }] = useMutation(LOGIN, {
    onError() {} // Always write this method for error handling in all mutation.
  });

  function successCallback(accessToken, refreshToken, userData) {
    initializeAuth(accessToken, refreshToken, userData);
    history.replace('/');
  }

  const onFinish = async (values) => {
    try {
      const response = await loginMutate({
        variables: { data: { ...values } }
      });
      const accessToken = get(response, 'data.login.token');
      const userData = get(response, 'data.login.user');
      const refreshToken = get(response, 'data.login.refreshToken');

      if (successCallback) {
        successCallback(accessToken, refreshToken, userData);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('error from login => ', error);
    }
  };

  return (
    <div className="gx-login-container">
      <div className="gx-login-header gx-text-center mb-0">
        <img src={logo} alt="Boilerplate" className="mb-4 fill-width" />
      </div>
      <Spin spinning={loginLoading} wrapperClassName="gx-login-content">
        <h1>Login</h1>
        <p>Sign In to your account</p>
        <Form
          name="Login"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          className="gx-login-form gx-form-row0"
        >
          <Form.Item name="email" rules={[required, email]}>
            <Input
              prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder="Email"
            />
          </Form.Item>

          <Form.Item name="password" rules={[required]}>
            <Input.Password
              prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder="Password"
            />
          </Form.Item>
          <div className="d-flex justify-between">
            <Form.Item className="gx-text-center">
              <Button type="primary" className="w-100" htmlType="submit">
                Login
              </Button>
            </Form.Item>
            <Form.Item className="d-flex mb-0 reset-password">
              <Link to={ROUTES.RESET}>Forgot password ?</Link>
            </Form.Item>
          </div>
        </Form>
      </Spin>
    </div>
  );
};

export default Login;
